import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-greyhounds.svg";
import * as styles from "./Icon.module.scss";

type GreyhoundsProps = React.SVGProps<SVGSVGElement>;

export const Greyhounds = ({ className, ...props }: GreyhoundsProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
